/* Taaralu Wishlist */
(function() {
  var STORAGE_KEY = 'taaralu_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch(e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateAllBadges();
    updateAllButtons();
  }

  function isInWishlist(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
  }

  function toggleWishlist(productId) {
    productId = String(productId);
    var list = getWishlist();
    var idx = list.indexOf(productId);
    if (idx === -1) list.push(productId);
    else list.splice(idx, 1);
    saveWishlist(list);
    return idx === -1;
  }

  function updateAllBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('.wishlist-badge').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-id]').forEach(function(btn) {
      if (btn.closest('.wishlist-page-overlay')) return;
      var id = btn.getAttribute('data-wishlist-id');
      var labelAdd = btn.dataset.labelAdd || '♡';
      var labelAdded = btn.dataset.labelAdded || '♥';
      if (isInWishlist(id)) {
        btn.classList.add('active');
        btn.innerHTML = labelAdded;
      } else {
        btn.classList.remove('active');
        btn.innerHTML = labelAdd;
      }
    });
  }

  function createOverlay() {
    var existing = document.getElementById('wishlistPageOverlay');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.id = 'wishlistPageOverlay';
    overlay.className = 'wishlist-page-overlay';

    var list = getWishlist();

    overlay.innerHTML =
      '<div class="wishlist-page-overlay__inner">'
      + '<div class="wishlist-page-overlay__top">'
      + '<h1 class="wishlist-page-overlay__title">My Wishlist</h1>'
      + '<button class="wishlist-page-overlay__close" id="wishlistPageClose">&times;</button>'
      + '</div>'
      + '<p class="wishlist-page-overlay__count">' + list.length + (list.length === 1 ? ' item' : ' items') + '</p>'
      + (list.length === 0 ? '<p class="wishlist-page-overlay__empty">Your wishlist is empty.<br><a href="/collections/all">Browse collection</a></p>' : '')
      + '<div class="wishlist-page-overlay__grid" id="wishlistPageGrid"></div>'
      + '</div>';

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    document.getElementById('wishlistPageClose').addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeOverlay();
    });

    if (!list.length) return;

    var grid = document.getElementById('wishlistPageGrid');

    fetch('/collections/all/products.json?limit=250')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.products || [];
        list.forEach(function(productId) {
          var product = null;
          for (var i = 0; i < products.length; i++) {
            if (String(products[i].id) === String(productId)) { product = products[i]; break; }
          }
          if (!product) return;

          var img = product.images && product.images.length ? product.images[0].src : '';
          var price = Number(product.variants[0].price).toLocaleString('en-IN');
          var cp = product.variants[0].compare_at_price;
          var priceHtml = '<span class="price-current">Rs. ' + price + '</span>';
          if (cp && cp > product.variants[0].price) {
            priceHtml += ' <span class="price-original">Rs. ' + Number(cp).toLocaleString('en-IN') + '</span>';
          }
          var disc = 0;
          if (cp && cp > product.variants[0].price) disc = Math.round((cp - product.variants[0].price) / cp * 100);

          var card = document.createElement('div');
          card.className = 'product-card';
          card.setAttribute('data-wishlist-card', productId);
          card.innerHTML =
            '<a href="/products/' + product.handle + '" class="card-image-wrap">'
            + '<img src="' + img + '" alt="' + product.title + '" class="card-img card-img--primary" loading="lazy">'
            + (disc > 0 ? '<span class="badge-discount">' + disc + '% off</span>' : '')
            + '<button class="wishlist-btn active" data-wishlist-id="' + product.id + '" aria-label="Remove">♥</button>'
            + '</a>'
            + '<div class="card-body">'
            + '<a href="/products/' + product.handle + '" class="product-name">' + product.title + '</a>'
            + '<div class="price-row">' + priceHtml + '</div>'
            + '<a href="/products/' + product.handle + '" class="add-to-cart-btn" style="text-align:center;text-decoration:none;display:block;">View product</a>'
            + '</div>';
          grid.appendChild(card);
        });
      });

    grid.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-wishlist-id]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(btn.getAttribute('data-wishlist-id'));
      var card = btn.closest('[data-wishlist-card]');
      if (card) card.remove();
      var rem = grid.querySelectorAll('[data-wishlist-card]');
      var countEl = overlay.querySelector('.wishlist-page-overlay__count');
      if (countEl) countEl.textContent = rem.length + (rem.length === 1 ? ' item' : ' items');
      if (!rem.length) {
        var emptyP = document.createElement('p');
        emptyP.className = 'wishlist-page-overlay__empty';
        emptyP.innerHTML = 'Your wishlist is empty.<br><a href="/collections/all">Browse collection</a>';
        grid.parentNode.insertBefore(emptyP, grid);
      }
    });
  }

  function closeOverlay() {
    var overlay = document.getElementById('wishlistPageOverlay');
    if (overlay) overlay.remove();
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-id]');
    if (btn && !btn.closest('.wishlist-page-overlay')) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(btn.getAttribute('data-wishlist-id'));
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    updateAllBadges();
    updateAllButtons();

    var toggle = document.getElementById('wishlistToggle');
    if (toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        createOverlay();
      });
    }
  });

  window.TaaraluWishlist = { get: getWishlist, toggle: toggleWishlist, isIn: isInWishlist };
})();
